import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from 'pinia';
import Notiflix from "notiflix";
import Aura from "@primevue/themes/aura";
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";

import "./registerServiceWorker";
import "./index.css";

// Centralized client configuration
import appConfig from "./app.config";



import AppSelect from "./components/base/AppSelect.vue";

// Patch PrimeVue Select alignOverlay bug (known issue in v4.x)
// The orientation media query listener calls alignOverlay even when
// the overlay is not open, causing "Cannot read properties of undefined (reading 'style')"
import SelectComponent from "primevue/select";
if (SelectComponent?.methods?.alignOverlay) {
  const _origAlign = SelectComponent.methods.alignOverlay;
  SelectComponent.methods.alignOverlay = function () {
    if (!this.overlay) return;
    _origAlign.call(this);
  };
}

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(PrimeVue, { theme: { preset: Aura, options: { darkModeSelector: '.dark' } } });

app.component("AppSelect", AppSelect);

import { useThemeStore } from './stores/theme';
const themeStore = useThemeStore(pinia);
themeStore.initTheme();

// Overrides de marca (white-label). Solo se aplican si el deploy los definió
// explícitamente: un inline style sobre <html> gana por especificidad a los
// valores por tema de index.css y dejaría el mismo color en claro y en oscuro.
const root = document.documentElement;
if (appConfig.theme.primary_color) root.style.setProperty('--color-primary', appConfig.theme.primary_color);
if (appConfig.theme.secondary_color) root.style.setProperty('--color-secondary', appConfig.theme.secondary_color);

// Provide appConfig for components using inject('appConfig')
app.provide('appConfig', appConfig);

app.use(router);

// Si hay una versión nueva esperando, se aplica en el próximo cambio de ruta:
// es un momento seguro (no hay formularios a medio completar en tránsito).
import { updateDisponible, aplicarActualizacion } from "./helpers/swUpdate";
router.afterEach(() => {
  if (updateDisponible.value) {
    aplicarActualizacion();
  }
});

app.mount("#app");

// Initialize Notiflix with theme color
const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || appConfig.theme.fallback_primary_color;
Notiflix.Loading.init({
  svgSize: "100px",
  svgColor: primaryColor,
  clickToClose: false,
});

document.body.classList.remove("overflow-hidden");
